import { Skeleton } from 'antd';
import { FileText } from 'lucide-react';

import { ToggleStage } from '@/components/Stage/ToggleStage';
import { cn } from '@/lib/cn';
import { DATE_FORMAT, getTimezoneDayjs } from '@/utils/time';

import type { HeySynclyAnswerStudioItem } from '../../model';

const STUDIO_ITEM_COMPLETE_STATUS = 'COMPLETE';
const STUDIO_ITEM_PENDING_STATUS = 'PENDING';

export function StudioItemPreview(props: {
  item: HeySynclyAnswerStudioItem;
  onClick: () => void;
  selected?: boolean;
  createdAt?: RFCDateString;
}) {
  const { item, onClick, createdAt } = props;

  const isLoading = item.status === STUDIO_ITEM_PENDING_STATUS;
  const isComplete = item.status === STUDIO_ITEM_COMPLETE_STATUS;

  return (
    <div
      className={cn(
        'flex min-w-0 rounded-2xl border px-4.5 py-4 transition-all duration-200',
        isComplete && 'cursor-pointer hover:bg-secondary',
      )}
      onClick={() => {
        if (isLoading) return;
        onClick();
      }}
    >
      <ToggleStage
        className="w-full min-w-0"
        status={!isLoading}
        fallback={
          <div className="flex flex-col w-full min-w-0 gap-2">
            <Skeleton.Node active style={{ width: '100%', height: 24 }} />
            <Skeleton.Node active style={{ width: 120, height: 14 }} />
            <Skeleton.Node active style={{ width: 100, height: 14 }} />
          </div>
        }
      >
        <div className="flex items-start w-full min-w-0 gap-6">
          <FileText className="size-5 shrink-0 text-card-foreground" />
          <div className="flex-1 min-w-0 overflow-hidden">
            <span className="block text-sm font-medium truncate text-card-foreground">
              {item.title}
            </span>
            {createdAt && (
              <span className="block mt-1 text-xs text-muted-foreground">
                Create at{' '}
                {getTimezoneDayjs(createdAt).format(DATE_FORMAT.readable)}
              </span>
            )}
          </div>
        </div>
      </ToggleStage>
    </div>
  );
}
